import LinkCard from './LinkCard';

export default LinkCard;
